/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_Reason_Too_ExpensiveInputs */

const en_settings_cancel_reason_too_expensive = /** @type {(inputs: Settings_Cancel_Reason_Too_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too expensive`)
};

const id_settings_cancel_reason_too_expensive = /** @type {(inputs: Settings_Cancel_Reason_Too_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harganya kemahalan`)
};

/**
* | output |
* | --- |
* | "Too expensive" |
*
* @param {Settings_Cancel_Reason_Too_ExpensiveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_reason_too_expensive = /** @type {((inputs?: Settings_Cancel_Reason_Too_ExpensiveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_Reason_Too_ExpensiveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_reason_too_expensive(inputs)
	return en_settings_cancel_reason_too_expensive(inputs)
});